export default __webpack_public_path__ + "static/media/familyInfographic.f3c00c31.png";